export const CountryCode = {
    DE: 'DE',
    PL: 'PL'
} as const;

export type CountryCodeValue = keyof typeof CountryCode;

export type CountryCodeKeys = (typeof CountryCode)[CountryCodeValue];
